import { ConfigProvider } from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import { TranslationProvider } from "./context/TranslationProvider.tsx";
import { initGA, trackPageView } from "./utils/analytics.ts";
import "./index.css";

// Initialize GA4
initGA();

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_REACT_APP_ENV || 'production',
  release: __APP_RELEASE_VERSION__,
});

// Track initial pageview
trackPageView(window.location.pathname);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#4586f0",
          colorError: "#D93721",
          colorWarning: "#F29B00",

          colorText: "#223B53",
          colorTextDescription: "#8C9CAB",
          colorTextHeading: "#223B53",
          colorTextPlaceholder: "#AFBCC9",
          colorTextLabel: "#223B53",
          colorTextBase: "#425A70",

          fontSize: 16,
          fontSizeHeading1: 24,
          fontSizeHeading2: 20,
          fontSizeHeading3: 18,
          fontFamily: "Roboto",
        },
      }}
    >
      <TranslationProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TranslationProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
